import { AppSidebar } from "@/components/layout/AppSidebar";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import { useTrackPageView } from "@/hooks/use-track-page-view";
import { CandidatoPanelGlobal } from "@/components/freelancers/painel/CandidatoPanelGlobal";

const CORISCO_LOGO = "/corisco-logo.png";

export function AppLayout() {
  const location = useLocation();
  useTrackPageView();

  // Preserva a rota atual no sessionStorage quando ela muda.
  useEffect(() => {
    sessionStorage.setItem("lastRoute", location.pathname + location.search);
  }, [location]);

  return (
    <CandidatoPanelGlobal>
      <SidebarProvider>
        <AppSidebar />
        <div className="flex h-svh min-w-0 flex-1 flex-col">
          {/* Top bar: no mobile o gatilho abre o drawer off-canvas; no desktop
              colapsa/expande a sidebar para o rail de ícones. Substitui o antigo
              botão flutuante mal-posicionado e o hack de pt-16. */}
          <header className="sticky top-0 z-30 flex h-14 shrink-0 items-center gap-2 border-b bg-background/80 px-3 backdrop-blur-sm md:px-4">
            <SidebarTrigger className="text-muted-foreground" />
            <img
              src={CORISCO_LOGO}
              alt="Corisco"
              className="h-6 w-auto md:hidden"
            />
          </header>
          <div className="flex-1 overflow-auto">
            <div className="p-4 md:p-6">
              <Outlet />
            </div>
          </div>
        </div>
      </SidebarProvider>
    </CandidatoPanelGlobal>
  );
}

export default AppLayout;
